import script from "./Document.vue?vue&type=script&setup=true&lang=js"
export * from "./Document.vue?vue&type=script&setup=true&lang=js"

import "./Document.vue?vue&type=style&index=0&id=1781f4ad&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1781f4ad"]])

export default __exports__